'use strict';

var $ = require('jquery');

var formsSelector = 'form';
var formWaitingClass = 'form--isWaiting';

var formButtons = 'span.btn';
var buttonWaitingClass = 'btn--isWaiting';
var waitingIndicatorClass = 'btn__waitingIndicator';

var focusClass = 'fieldArea--isFocus';
var hoverClass = 'fieldArea--isHover';
var filledClass = 'fieldArea--isFilled';

var formFieldSelector = 'input, select, textarea';

var $document = $(document);

function setupButtons() {
	// Setup all buttons that aren't already setup.
	var $buttons = $(formButtons);
	setupTheseButtons($buttons);
};
function setupTheseButtons($buttons) {
	$buttons.each(function() {
		var $this = $(this);
		if ($this.find('.' + waitingIndicatorClass).length == 0) {
			$this.append('<span class='+waitingIndicatorClass+'/>');
		}
	});
};

var Forms = {};

Forms.pauseForms = function($forms) {
	setupButtons(); // Ensure all buttons are setup.
	
	$forms = $forms || $(formsSelector);
	toggleForms($forms, true);
};
Forms.releaseForms = function() {
	var $forms = $(formsSelector);
	toggleForms($forms, false);
};
function toggleForms($forms, state) {
	$forms.toggleClass(formWaitingClass, state);
	$(formButtons, $forms).toggleClass(buttonWaitingClass, state);
}

function elementInViewport(el, acceptPartiallyVisible) {
	acceptPartiallyVisible = acceptPartiallyVisible !== undefined ? acceptPartiallyVisible : false;
	var top = el.offsetTop;
	var left = el.offsetLeft;
	var width = el.offsetWidth;
	var height = el.offsetHeight;

	while(el.offsetParent) {
		el = el.offsetParent;
		top += el.offsetTop;
		left += el.offsetLeft;
	}

	if (acceptPartiallyVisible) {
		return (
			    top < (window.pageYOffset + window.innerHeight) &&
			    left < (window.pageXOffset + window.innerWidth) &&
			    (top + height) > window.pageYOffset &&
			    (left + width) > window.pageXOffset
			  );
	} else {
		return (
				top >= window.pageYOffset &&
				left >= window.pageXOffset &&
				(top + height) <= (window.pageYOffset + window.innerHeight) &&
				(left + width) <= (window.pageXOffset + window.innerWidth)
		);
	}
}

/**
 * Scroll page to messages if there are any and the user is not already scrolled down
 */
Forms.scrollToMessages = function() {
	var $msgs = $('.messages');
	if ($msgs.length !== 0) {
		if (!elementInViewport($msgs.get(0), false)) {
			var offset = $msgs.first().offset();

			var sectionScroller = $(document.body).data('sectionScroller');
			if (sectionScroller !== undefined) {
				sectionScroller.animateTo(offset.left, offset.top);
			} else {
				var $body = $(document.body);
				$body
					.stop()
					.animate({'scrollTop' : offset.left}, 1000, 'easeOutQuart')
				;
			}
		}
	}
}

/**
 * Initialize forms. Can be called multiple times to reset forms.
 */
Forms.init = function() {
	
	// Immediately setup any buttons that are already waiting
	setupTheseButtons($('.' + buttonWaitingClass));
	
	$document.on('jsfAjaxBegin submit', function(event, extraData) {
		if ($(formsSelector).hasClass(formWaitingClass)) {
			// We are waiting on a form. Do not do anything.
			event.preventDefault();
			return false;
		} else {
			var $forms = undefined;
			if (event.type === 'a4jSubmit' && extraData !== undefined) {
				// Richfcaes
				if (extraData.request !== undefined && extraData.request.form !== undefined) {
					Forms.pauseForms($(extraData.request.form));
				}
			} else if (event.type === 'submit') {
				// Normal form submission
				var $forms = $(event.target);
				Forms.pauseForms($forms);
			} else {
				// Catchall. Since we may not know the specific form we pause all of them
				Forms.pauseForms();
			}
		}
	});
	
	$document.on('jsfAjaxAlways', function(event, extraData) {
		// Release form
		Forms.releaseForms();
		
		Forms.scrollToMessages();
		markFilledInFields();
	});

	// Add a class to fieldArea when user is hovering over or has focus on a form field. We use this to show any field specific messages.
	$document.on('mouseenter mouseleave focus blur', formFieldSelector, formFieldEventListener);

	// Add a class to fieldArea when not empty
	$document.on('change keyup', formFieldSelector, markFilledInFields);
	markFilledInFields();
}

function formFieldEventListener(event) {
	var $input = $(this);
	var $area = $input.closest('.fieldArea');

	if ($area.length === 0)
		return;

	var eventType = event.type;

	if (eventType === 'mouseenter') {
		$area.addClass(hoverClass);
	} else if (
		(eventType === 'mouseleave' && !$area.hasClass(focusClass)) ||
		(eventType === 'blur') ||
		(eventType === 'focusout')
	) {
		$area.removeClass(hoverClass);
		$area.removeClass(focusClass);
	} else if (eventType.indexOf('focus') > -1) {
		if (($input.get(0).type === 'select-one') && $area.hasClass(hoverClass)) {
			// Remove if user clicked to open a select one field. Otherwise the arrow is partially visible.
			$area.removeClass(focusClass);
		} else {
			$area.addClass(focusClass);
		}
	}
}

function markFilledInFields() {
	var $input = $(this);
	var $area = $input.closest('.fieldArea');
	
	if ($area.length === 0)
		return;

	var addClass = false;
	if ($input.attr('type') == 'checkbox'){
		addClass = $input.get(0).checked;
	} else {
		addClass = $input.val() !== '';
	}

	$area.toggleClass(filledClass, addClass);
}


module.exports = Forms; 
